module.exports = __webpack_public_path__ + "static/img/fish3.4637137.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/starfish/fish3.png
// module id = 1Wg8
// module chunks = 0